module.exports = __webpack_public_path__ + "static/img/next.52f85be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/next.png
// module id = liws
// module chunks = 21